import React from 'react';
import './spinner.scss';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
const Spinn = (props) => {
  return (
    <div className="spinner-container">
      <div className="loader">
        <div className="face">
          <div className="circle"></div>
        </div>
        <div className="face">
          <div className="circle"></div>
        </div>
        <div className="face"></div>
        <h6 style={{ direction: props.direction }}>
          <FormattedMessage id="profile.loading" />
        </h6>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { direction } = state.language;
  return { direction };
};
export const Spinner = connect(mapStateToProps)(Spinn);
